const texts = {
    navigationEtapes: "Navigation par étapes",
    etape: "Étape",
    etapeActuelle: " (étape actuelle)",
    etapeCompletee: " (étape complétée)",
    etapeAVenir: " (étape à venir)",
}

export default texts
